import React from 'react';
import { Icon } from 'ui';

const Group = ({ name, editable, onRemove, removeTooltip }) => (
  <div className="fz-base c-brand-gray-darker mb-4 p-4 ai-c d-f jc-sb bdrs-base h-bc-gray-lightest">
    <div>{name}</div>
    {editable && (
      <div>
        <button
          type="button"
          className="u-resetBtn c-brand-gray h-c-gray-darker"
          onClick={onRemove}
          data-toggle="tooltip"
          data-original-title={removeTooltip}
        >
          <Icon name="delete" />
        </button>
      </div>
    )}
  </div>
);

Group.defaultProps = {
  editable: false,
};

export default Group;
